import { Formik, Form } from 'formik';
import { Box } from '@mui/material';
import { BranchSelector } from './BranchSelector';
import { LoginError } from './LoginError';
import { CustomButton, CustomTextField } from '../../../common';

export const LoginFormFields = ({
  isLoggedIn,
  branches,
  selectedBranch,
  errorMessage,
  authLoading,
  showBranchSelector,
  canProceed,
  validationSchema,
  initialValues,
  handleSubmit,
  handleBranchChange,
  handleBranchConfirm,
  clearError,
  handleEmailChange,
  openRecoveryDialog,
}) => (
  <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
    {({ values, errors, touched, setFieldValue, isSubmitting }) => (
      <Form>
        <Box sx={{ marginTop: '30px' }}>
          {!isLoggedIn && (
            <>
              <CustomTextField
                name="usuario"
                label="Dirección de email"
                type="email"
                placeholder="email@email.com"
                value={values.usuario}
                error={touched.usuario && Boolean(errors.usuario)}
                helperText={touched.usuario && errors.usuario}
                onChange={(e) => {
                  const value = e.target.value;
                  setFieldValue('usuario', value);
                  clearError();
                  if (handleEmailChange) {
                    handleEmailChange(value);
                  }
                }}
              />

              <CustomTextField
                name="password"
                label="Contraseña"
                type="password"
                placeholder="*********"
                value={values.password}
                error={touched.password && Boolean(errors.password)}
                helperText={touched.password && errors.password}
                onChange={(e) => {
                  setFieldValue('password', e.target.value);
                  clearError();
                }}
              />
            </>
          )}

          {showBranchSelector && (
            <BranchSelector
              branches={branches}
              selectedBranch={selectedBranch}
              onChange={handleBranchChange}
            />
          )}

          {errorMessage && <LoginError message={errorMessage} />}

          <CustomButton
            type={isLoggedIn ? 'button' : 'submit'}
            sx={{ mt: 2 }}
            variant="base"
            fullWidth
            onClick={isLoggedIn ? handleBranchConfirm : undefined}
            disabled={!canProceed || isSubmitting || authLoading}
            loading={authLoading}
          >
            {isLoggedIn && selectedBranch ? 'Ingresar' : 'Iniciar sesión'}
          </CustomButton>

          {!isLoggedIn && (
            <CustomButton
              type="button"
              variant="text"
              sx={{ mt: 1.5, fontWeight: 400, width: '100%' }}
              onClick={openRecoveryDialog}
            >
              ¿Olvidaste tu contraseña?
            </CustomButton>
          )}
        </Box>
      </Form>
    )}
  </Formik>
);
